import { request } from '@/utils/request';
import { ChangePasswordForm, FindAccountForm, LoginForm, SignupForm } from './interface';

/** [계정] 로그인 */
export const login = async (loginForm: LoginForm) => {
  const { data } = await request().post('/accounts/login', {
    ...loginForm,
    provider: 'doctornow',
    role: 'pharmacy'
  });
  return data;
};

/** [계정] 회원가입 */
export const signup = async (signupForm: SignupForm) => {
  const formData = new FormData();
  formData.append('usernameOrEmail', signupForm.username.trim());
  formData.append('passwordOrAppId', signupForm.password.trim());
  formData.append('role', 'pharmacy');
  formData.append('provider', 'doctornow');
  formData.append(
    'onBoardingDetail',
    JSON.stringify({
      pharmacyDetail: {
        name: signupForm.pharmName,
        email: signupForm.email,
        roadAddress: signupForm.roadAddress,
        jibunAddress: signupForm.jibunAddress,
        detailAddress: signupForm.detailAddress,
        tel: signupForm.tel,
        fax: signupForm.fax,
        longitude: signupForm.longitude,
        latitude: signupForm.latitude,
        zipCode: signupForm.zonecode
      },
      pharmacistDetail: {
        pharmacistName: signupForm.pharmacistName,
        phone: signupForm.phone,
        brandName: signupForm.brandName,
        businessLicenseNumber: signupForm.businessLicenseNumber,
        representativeName: signupForm.representativeName,
        bankAccount: {
          bank: signupForm.bank,
          account: signupForm.account,
          accountName: signupForm.accountName
        }
      }
    })
  );
  formData.append('license', signupForm.license);
  formData.append('bankbookImage', signupForm.bankbookImage);
  formData.append(
    'corporateRegistrationImage',
    signupForm.corporateRegistrationImage
  );
  const { data } = await request().post('/accounts', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data;
};

/** [계정] 아이디 찾기 */
export const findId = async (findAccountForm: FindAccountForm) => {
  const { data } = await request().post('/accounts/find-id', {
    phone: findAccountForm.input,
    token: findAccountForm.token,
    role: 'pharmacy'
  });
  return data.result;
};

/** [계정] 비밀번호 찾기 (비밀번호 변경 토큰 발급) */
export const findPassword = async (findAccountForm: FindAccountForm) => {
  const { data } = await request().post('/accounts/find-password', {
    username: findAccountForm.username,
    phone: findAccountForm.input,
    token: findAccountForm.token,
    role: 'pharmacy'
  });
  return data.result;
};

/** [계정] 비밀번호 변경 */
export const changePassword = async (
  changePasswordForm: ChangePasswordForm
) => {
  const { accessToken, newPassword } = changePasswordForm;
  const { data } = await request(accessToken).put('/accounts/reset-password', {
    newPassword: newPassword
  });
  return data.success;
};

export default {
  login,
  signup,
  findId,
  findPassword,
  changePassword,
};
